export const FETCH_MESSAGES = "FETCH_MESSAGES"
export const FETCH_TETRISGAMESCORES = "FETCH_TETRISGAMESCORES"
export const FETCH_WHACKAMOLEGAMESCORES = "FETCH_WHACKAMOLEGAMESCORES"
export const FETCH_SNAKEGAMESCORES = "FETCH_SNAKEGAMESCORES"
export const FETCH_2048GAMESCORES = "FETCH_2048GAMESCORES"